/*
 * 功能模块的颜色变量配置
 */

import { ThemeColors } from '..';

export const commonColors: ThemeColors = {
  color: {
    // text
    'common-text-base-color': 'var(--common-text-base-color)',

    // button
    'common-project-header-name-color': 'var(--common-project-header-name-color)',
    'common-button-text-color': 'var(--common-button-text-color)',
    'common-button-text-disabled-color': 'var(--common-button-text-disabled-color)',
    'common-project-credit-text-color': 'var(--common-project-credit-text-color)',
    'common-logo-color': 'var(--common-logo-color)',

    // popver menu text
    'common-popover-menu-text-color': 'var(--common-popover-menu-text-color: #282828)',
    'common-popover-menu-text-danger-color':
      'var(--common-popover-menu-text-danger-color)',
    'common-modal-upload-popover-tip-title':
      'var(--common-modal-upload-popover-tip-title)',

    // tag
    'common-modal-seat-tag-color': 'var(--common-modal-seat-tag-color)',

    // user
    'common-popover-user-balance': 'var(--common-popover-user-balance)',
    'common-popover-user-border': 'var(--common-popover-user-border)',

    // task card
    'common-task-card-progress-color': 'var(--common-task-card-progress-color)',
    'common-task-card-success-color': 'var(--common-task-card-success-color)',
    'common-task-card-error-color': 'var(--common-task-card-error-color)',
    'common-task-card-num-color': 'var(--common-task-card-num-color)',
    'common-task-card-export-btn-color': 'var(--common-task-card-export-btn-color)',
    'common-task-card-time-color': 'var(--common-task-card-time-color)',
    'common-task-card-title-color': 'var(--common-task-card-title-color)',

    // upload
    'common-modal-upload-popover-text-color':
      'var(--common-modal-upload-popover-text-color)',
    'common-modal-upload-popover-tip-color':
      'var(--common-modal-upload-popover-tip-color)',

    // v1.1 基础颜色
    'color-info': 'var(--color-info)',
    'color-info-active': 'var(--color-info-active)',
    'color-info-disabled': 'var(--color-info-disabled)',
    'color-info-hover': 'var(--color-info-hover)',
    'color-warning': 'var(--color-warning)',
    'color-warning-active': 'var(--color-warning-active)',
    'color-warning-hover': 'var(--color-warning-hover)',
    'color-danger': 'var(--color-danger)',
    'color-danger-active': 'var(--color-danger-active)',
    'color-danger-hover': 'var(--color-danger-hover)',
    'color-primary': 'var(--color-primary)',
    'color-primary-active': 'var(--color-primary-active)',
    'color-primary-disabled': 'var(--color-primary-disabled)',
    'color-primary-hover': 'var(--color-primary-hover)',
    'color-fill-0': 'var(--color-fill-0)',
    'color-fill-1': 'var(--color-fill-1)',
    'color-fill-2': 'var(--color-fill-2)',
    'color-highlight': 'var(--color-highlight)',
    'color-highlight-bg': 'var(--color-highlight-bg)',
    'color-success': 'var(--color-success)',
    'color-success-active': 'var(--color-success-active)',
    'color-success-disabled': 'var(--color-success-disabled)',
    'color-success-hover': 'var(--color-success-hover)',
    'color-text-0': 'var(--color-text-0)',
    'color-text-1': 'var(--color-text-1)',
    'color-text-2': 'var(--color-text-2)',
    'color-text-3': 'var(--color-text-3)',
    'color-secondary': 'var(--color-secondary)',
    'color-secondary-active': 'var(--color-secondary-active)',
    'color-secondary-disabled': 'var(--color-secondary-disabled)',
    'color-secondary-hover': 'var(--color-secondary-hover)',
    'color-secondary-light-hover': 'var(--color-secondary-light-hover)',
    'color-tertiary': 'var(--color-tertiary)',
    'color-tertiary-active': 'var(--color-tertiary-active)',
    'color-tertiary-hover': 'var(--color-tertiary-hover)',
    'color-link': 'var(--color-link)',
    'color-link-active': 'var(--color-link-active)',
    'color-link-hover': 'var(--color-link-hover)',
    'color-link-visited': 'var(--color-link-visited)',
    'color-shadow': 'var(--color-shadow)',
    'color-black': 'var(--color-black)',
    'color-default': 'var(--color-default)',
    'color-default-active': 'var(--color-default-active)',
    'color-default-hover': 'var(--color-default-hover)',

    // 超链接
    'common-link-color': 'var(--common-link-color)',
    'common-link-hover-color': 'var(--common-link-hover-color)',
    'common-link-active-color': 'var(--common-link-active-color)',
    'common-link-visited-color': 'var(--common-link-visited-color)',
  },
  backgroundColor: {
    // container
    'common-page-bg-color': 'var(--common-page-bg-color)',
    'common-contaier-bg-color': 'var(--common-contaier-bg-color)',
    'common-contaier-item-bg-color': 'var(--common-contaier-item-bg-color)',
    'common-contaier-item-element-bg-color':
      'var(--common-contaier-item-element-bg-color)',

    // media controller
    'common-controller-bar-progress-color': 'var(--common-text-base-color)',
    'common-controller-bar-track-color': 'var(--common-controller-bar-track-color)',

    // modal
    'common-modal-bg': 'var(--common-modal-bg)',

    // modal upload
    'common-modal-upload-popover-progress-track-color':
      'var(--common-modal-upload-popover-progress-track-color)',

    // popover
    'common-popover-menu-bg': 'var(common-popover-menu-bg)',

    // button
    'common-button-bg-color': 'var(--common-button-bg-color)',
    'common-button-bg-hover-color': 'var(--common-button-bg-hover-color)',
    'common-button-bg-active-color': 'var(--common-button-bg-active-color)',
    'common-button-bg-disabled-color': 'var(--common-button-bg-disabled-color)',

    // user
    'common-popover-user-bg': 'var(--common-popover-user-bg)',
    'common-popover-user-benefit-bg': 'var(--common-popover-user-benefit-bg)',

    // upload
    'common-modal-upload-popover-bg-color': 'var(--common-modal-upload-popover-bg-color)',
    'common-modal-upload-popover-progress-color':
      'var(--common-modal-upload-popover-progress-color)',
    'common-modal-upload-popover-script-input-bg':
      'var(--common-modal-upload-popover-script-input-bg)',
    'common-modal-seat-tag-bg': 'var(--common-modal-seat-tag-bg)',

    // tab
    'common-tab-action-button-bg-color': 'var(--common-tab-action-button-bg-color)',
    'common-tab-slider-main-bg': 'var(--common-tab-slider-main-bg)',
    'common-tab-slider-indicator-bg': 'var(--common-tab-slider-indicator-bg)',

    // menu
    'common-menu-bg-color': 'var(--common-menu-bg-color)',
    'common-menu-item-bg-color': 'var(--common-menu-item-bg-color)',
    'common-menu-item-active-bg-color': 'var(--common-menu-item-active-bg-color)',

    // task card
    'common-task-card-bg-color': 'var(--common-task-card-bg-color)',
    'common-task-card-tag-bg-color': 'var(--common-task-card-tag-bg-color)',
    'common-task-card-main-bg': 'var(--common-task-card-main-bg)',
    'common-secondary-button-bg-color': 'var(--common-secondary-button-bg-color)',
    'common-task-card-export-btn-bg': 'var(--common-task-card-export-btn-bg)',
    'common-task-card-item-popover-bg': 'var(--common-task-card-item-popover-bg)',
    'common-project-header-bg': 'var(--common-project-header-bg)',
    'common-project-input-bg': 'var(--common-project-input-bg)',
    'common-project-credit-bg-color': 'var(--common-project-credit-bg-color)',
    'common-task-card-item-popover-color': 'var(--common-task-card-item-popover-color)',
    'common-task-card-empty-bg': 'var(--common-task-card-empty-bg)',

    // v1.1 背景色
    'color-bg-0': 'var(--color-bg-0)',
    'color-bg-0-2': 'var(--color-bg-0-2)',
    'color-bg-1': 'var(--color-bg-1)',
    'color-bg-2': 'var(--color-bg-2)',
    'color-bg-3': 'var(--color-bg-3)',
    'color-bg-4': 'var(--color-bg-4)',
    'color-nav-bg': 'var(--color-nav-bg)',
    'color-nav-bg-1': 'var(--color-nav-bg-1)',
    'color-nav-bg-2': 'var(--color-nav-bg-2)',
    'color-overlay-bg': 'var(--color-overlay-bg)',
    'color-overlay-bg-2': 'var(--color-overlay-bg-2)',
    'color-overlay-bg-3': 'var(--color-overlay-bg-3)',
  },
  borderColor: {
    'common-project-credit-border-color': 'var(--common-project-credit-border-color)',

    // v1.1 边框颜色
    'color-border': 'var(--color-border)',
    'color-focus-border': 'var(--color-focus-border)',
  },
};
